import React from 'react';
import { Chip, ChipProps, Typography } from '@mui/material';

import { DealActivityStatus } from '@trnsact/trnsact-shared-types';

interface Props {
  status: DealActivityStatus;
}

const STATUS_LABELS: Record<DealActivityStatus, string> = {
  [DealActivityStatus.None]: 'None',
  [DealActivityStatus.Open]: 'Open',
  [DealActivityStatus.Closed]: 'Closed',
  [DealActivityStatus.Cancelled]: 'Cancelled',
};

const STATUS_COLORS: Record<DealActivityStatus, ChipProps['color']> = {
  [DealActivityStatus.None]: 'default',
  [DealActivityStatus.Open]: 'info',
  [DealActivityStatus.Closed]: 'success',
  [DealActivityStatus.Cancelled]: 'error',
};

export const StatusCell = ({ status }: Props) => (
  <Chip
    size="small"
    color={STATUS_COLORS[status] ?? 'default'}
    label={<Typography>{STATUS_LABELS[status] ?? status}</Typography>}
  />
);
